import Constants from '../common/constants';

const { ReduxAction } = Constants;

const initialState = {
  [process.env.REACT_APP_TOKEN_NAME]: null,
  isAuthenticated:                    null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ReduxAction.Login:
      return {
        ...state,
        [process.env.REACT_APP_TOKEN_NAME]: payload.token,
        isAuthenticated:                    true,
      };

    case ReduxAction.Signup:
      return {
        ...state,
        [process.env.REACT_APP_TOKEN_NAME]: payload.token,
        isAuthenticated:                    true,
      };

    case ReduxAction.TokenExpired:
    case ReduxAction.AuthFailed:
    case ReduxAction.Logout:
      return {
        ...state,
        [process.env.REACT_APP_TOKEN_NAME]: null,
        isAuthenticated:                    false,
        // we set token = null because
        // some user will still logged-in already when we release this PR
        // so token value is persisted in their browser , we need to clear token value when they logged out.
        // for our testing , we clear localStorage ourself , but user won't do like this. so we need to clear behalf of them.
        token:                              null,
      };

    default:
      return state;
  }
}
